"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SpeechBubble_1 = __importDefault(require("Tooltip/SpeechBubble/SpeechBubble"));
var AcceptDisabledService_1 = __importDefault(require("./AcceptDisabledService"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var react_1 = __importDefault(require("react"));
var AcceptFlow_1 = require("./AcceptFlow");
var Environment_1 = require("@CommonFrontendBackend/Environment");
var AgreementComponent_1 = require("../Agreement/AgreementComponent");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
exports.default = angular
    .module("publicAcceptButton", [])
    .directive("publicAcceptButton", function ($rootScope, createUi) { return ({
    restrict: "E",
    template: "\n  <div class=\"accept-wrapper\" tabindex=\"-1\" data-unfurl-form-for-printing=\"{{unfurlFormForPrinting}}\" data-accepter-count=\"{{incompleteAccepterCount}}\">\n    <div class=\"action-button-wrapper\" ng-class=\"{'unfurled': unfurlFormForPrinting == true && incompleteAccepterCount > 0 }\" ng-if=\"(unfurlFormForPrinting || !showInlineForm)\">\n      <accept-button-v2\n        block-style=blockStyle\n        label={{label}}\n        editable=\"false\"\n        on-change=\"null\"\n        click=click\n        accepters=accepters\n        settings=settings\n        is-disabled=isDisabled\n        hide-multi-accepters=hideMultiAccepters\n        is-in-navigation=isInNavigation\n        agreement-block=agreementBlock\n        >\n      </accept-button-v2>\n    </div> \n    \n    <div ng-class=\"{'print-styling-V2': usingPrintStylingV2 == true}\">\n      <div class=\"accept-form-layout-container\">\n        <div ui=acceptFlow class=\"react-accept-wrapper\" ng-class=\"{'unfurled': unfurlFormForPrinting == true && incompleteAccepterCount > 0 }\" ng-if=\"showInlineForm\"></div>\n      </div>\n    </div>\n    <div ui=agreementModal ng-if=\"(!!agreementBlock)\"></div>\n  </div>\n  ",
    scope: {
        label: "@",
        blockStyle: "=",
        accepters: "=",
        settings: "=?",
        hideMultiAccepters: "=?",
        usingPrintStylingV2: "=?",
        targetSelector: "@?",
        tooltipPosition: "@?",
        isInNavigation: "=?",
        agreementBlock: "=?",
        agreementStyles: "=?",
    },
    controller: function ($scope, $interval, $timeout) {
        var _a, _b, _c;
        var childScope = $rootScope.di.child();
        var speechBubble = childScope.invoke(SpeechBubble_1.default);
        var acceptDisabledService = childScope.make(AcceptDisabledService_1.default);
        var isPrintMode = $rootScope.di.get("isPrintMode");
        var usingFeature = $rootScope.di.get("usingFeature");
        $scope.usingPrintStylingV2 = usingFeature(FeatureFlag_1.default.PrintStylingV2) && isPrintMode;
        var projectSecret = $rootScope.di.get("projectSecret");
        var projectStatus = $rootScope.di.get("projectStatus");
        var urlParams = new URLSearchParams(window.location.search);
        var agreementViewSearchParam = urlParams.get("agreementView");
        var isAgreementPrintMode = isPrintMode && agreementViewSearchParam === "true";
        var env = $rootScope.di.get("environment");
        var telemetry = $rootScope.di.get("acceptTelemetry");
        $scope.acceptFlow = (0, MountReactComponent_1.default)(createUi, childScope)(react_1.default.createElement(AcceptFlow_1.PublicAcceptFlow, {
            onClose: function () {
                $timeout($scope.handleCloseInlineForm);
                telemetry.track("Accept Form Dismissed", {});
            },
            accepters: $scope.accepters,
            settings: $scope.settings,
            autofillEnabled: (0, Environment_1.isNonProductionEnvironment)(env),
            $timeout: $timeout,
            requiresQuoteChoice: acceptDisabledService.requiresQuoteChoice,
        }));
        $scope.showAgreementModal = isAgreementPrintMode || false;
        var publicHost = "".concat(window.location.protocol, "//").concat(window.location.hostname);
        $scope.agreementModal = (0, MountReactComponent_1.default)(createUi, childScope)(react_1.default.createElement(AgreementComponent_1.AgreementModalContainer, {
            onDismiss: function () {
                $timeout($scope.handleCloseAgreementModal);
            },
            $scope: $scope,
            $timeout: $timeout,
            accepters: $scope.accepters,
            acceptBlockSettings: $scope.settings,
            autofillEnabled: (0, Environment_1.isNonProductionEnvironment)(env),
            acceptBlockStyles: $scope.agreementStyles,
            disableNavigationButton: acceptDisabledService.isAgreementNavigationButtonDisabled(),
            acceptedInCurrentSession: acceptDisabledService.isAcceptedInCurrentSession,
            isPrintMode: isAgreementPrintMode,
            pdfUrl: "".concat(publicHost, "/pdf/").concat(projectSecret),
            projectStatus: projectStatus,
            requiresQuoteChoice: acceptDisabledService.requiresQuoteChoice,
        }));
        $scope.unfurlFormForPrinting = isPrintMode;
        var maxAccepters = (_a = $scope.accepters.number) !== null && _a !== void 0 ? _a : 0;
        var finalisedAccepters = (_c = (_b = $scope.accepters.finalisedAccepters) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        $scope.incompleteAccepterCount = maxAccepters - finalisedAccepters;
        $scope.handleCloseInlineForm = function () {
            $scope.showInlineForm = false;
        };
        $scope.handleCloseAgreementModal = function () {
            $scope.showAgreementModal = false;
        };
        if ($scope.unfurlFormForPrinting) {
            $scope.showInlineForm = true;
        }
        $scope.click = function () {
            if ($scope.agreementBlock) {
                $scope.showAgreementModal = true;
            }
            else if (acceptDisabledService.isDisabled()) {
                if (!!$scope.targetSelector) {
                    var reason = acceptDisabledService.getDisabledReason();
                    if (!!reason) {
                        speechBubble.explain({
                            targetSelector: $scope.targetSelector,
                            message: reason,
                            position: $scope.tooltipPosition || null,
                        });
                    }
                }
            }
            else {
                $scope.showInlineForm = true;
            }
        };
        $scope.isDisabled = function () {
            return !$scope.agreementBlock && acceptDisabledService.isDisabled();
        };
    },
}); });
